app.service('sessionStorage', function () {

	function getItem(name) {
		return window.sessionStorage.getItem(name);
	}
	function setItem(name, value) {
		window.sessionStorage.setItem(name, value);
	}

	function empty(name) {
		return (getItem(name) === null || getItem(name) === '');
	}
	function removeItem(name) {
		window.sessionStorage.removeItem(name);
	}

	return {
		getItem,
		setItem,
		removeItem,
		empty
	};
});
